import stateConfig from './config'

export default {
  setPage: function ({ commit }, payload) {
    commit(stateConfig.SET_PAGE, payload)
  }
}
